import React from 'react';
import {withFirestore} from 'react-firestore';

import MsgNetLoading from '../components/MsgNetLoading';
import ControlSelector from '../components/ControlSelector';
import ResultadoList from '../components/ResultadoList';

import CompeticionHeaderMenu from '../components/CompeticionHeaderMenu';
import GeneroSelector from '../components/GeneroSelector';
import SharePanel from '../components/SharePanel';
import TopHeaderMenu from '../components/TopHeaderMenu';

const RESULTADOS_MOSTRAR = 10

class CompeticionScreen extends React.Component {
  // ...
  constructor (props) {
    super(props)

    let resultados = []
    let i = 0
    while (i < 10) {
      resultados.push({
        puesto: 0,
        nombre: '...',
        apellidos: '',
        dorsal: i,
        tiempo: 0,
        preload: true
      })
      i++
    }
    this.state = {
      evento: null,
      competicion: null,
      sectores: [],
      controles: [],
      controlId: null,
      resultados: resultados,
      generoSelectedIndex: 1,
      showSharePanel: false
    }
    this.unlisten = {}
    // Controles con algún resultado
    // o a los que hemos cambiado automaticamente para mostrar.
    this.controlesVistos = []
  }

  toogleSharePanel () {
    this.setState(state => ({
      showSharePanel: !this.state.showSharePanel
    }))
  }

  _setDefaultResultados () {
    let resultados = []
    let i = 0
    while (i < 10) {
      resultados.push({
        puesto: 0,
        nombre: '...',
        apellidos: '',
        dorsal: i,
        tiempo: 0,
        preload: true
      })
      i++
    }
    this.setState({
      resultados: resultados
    })
  }

  componentDidMount () {
    const { firestore } = this.props
    // let controlId = parseInt(this.props.match.params.controlId, 10)
    const competicionId = parseInt(this.props.match.params.competicionId, 10)

    this.unlisten.competicion = firestore.doc('competicion/' + competicionId).onSnapshot(snapshot => {
      let competicion = snapshot ? snapshot.data() : null
      if (competicion) {
        competicion.id = snapshot.id
      }
      this.setState({ competicion })
    })

    this.unlisten.controles = firestore.collection('control/')
      .where('competicion_id', '==', competicionId)
      .where('visible', '==', true)
      .orderBy('distancia', 'asc')
      .onSnapshot((snapshot) => {
        let controles = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }))
        this.setState({ controles })
      })

    this.unlisten.sectores = firestore.collection('sector/')
      .where('competicion_id', '==', competicionId)
      .orderBy('inicio', 'asc')
      .onSnapshot((snapshot) => {
        let sectores = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }))
        this.setState({ sectores })
      })
  }

  onClickBack () {
    this.props.history.push(`/${this.state.competicion.evento_id}`)
  }

  _seleccionaResultadosAdecuados (nextState) {
    this._setDefaultResultados()

    const state = nextState || this.state

    if (this.unlisten.resultados) {
      // Desconectamos el "listener" previo a resultados
      this.unlisten.resultados()
    }

    let generoSelectedIndex = state.generoSelectedIndex
    if (state.competicion.mostrar_filtro_sexo) {

    } else {
      generoSelectedIndex = 1
    }

    if (generoSelectedIndex === 1) {
      this.unlisten.resultados = this.props.firestore.collection('resultado')
        .where('control_' + state.controlId + '_puesto', '>', 0)
        .orderBy('control_' + state.controlId + '_puesto', 'asc')
        .limit(state.competicion.resultados_control_mostrar || RESULTADOS_MOSTRAR)
        .onSnapshot((snapshot) => {
          let resultados = snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }))
          this.setState({ resultados: resultados })
        })
    } else if (generoSelectedIndex === 2) {
      this.unlisten.resultados = this.props.firestore.collection('resultado')
        .where('control_' + state.controlId + '_puesto_M', '>', 0)
        .orderBy('control_' + state.controlId + '_puesto_M', 'asc')
        .limit(state.competicion.resultados_control_mostrar || RESULTADOS_MOSTRAR)
        .onSnapshot((snapshot) => {
          let resultados = snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }))
          this.setState({ resultados: resultados })
        })
    } else if (generoSelectedIndex === 3) {
      this.unlisten.resultados = this.props.firestore.collection('resultado')
        .where('control_' + state.controlId + '_puesto_F', '>', 0)
        .orderBy('control_' + state.controlId + '_puesto_F', 'asc')
        .limit(state.competicion.resultados_control_mostrar || RESULTADOS_MOSTRAR)
        .onSnapshot((snapshot) => {
          let resultados = snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }))
          this.setState({ resultados: resultados })
        })
    }
  }

  UNSAFE_componentWillUpdate (nextProps, nextState) { // eslint-disable-line
    // Si no especificamos el control en el router buscamos
    // siempre el último con resultados al actualizarse la lista de controles.
    if (this.state.controles !== nextState.controles) {
      // Para cada control vemos si el número de llegados subió de 0, para cambiar automáticamente a el.
      // Si no cogemos el último con resultados,
      // siempre que this.state.controles esté vació (significa que acabamos de entrar)
      const old = this.state.controles
      const now = nextState.controles
      // console.info(old)
      // console.info(now)
      if (old.length === 0 && now.length) {
        // Este es el momento en que se cargan los controles por primera vez...
        let conResultados = now.filter(a => {
          return a.numero_llegados > 0
        })
        if (conResultados.length) {
          this.setState({ controlId: parseInt(conResultados[conResultados.length - 1].id, 10) })
        } else {
          // Vamos al primero
          this.setState({ controlId: parseInt(now[0].id, 10) })
        }
      } else {
        // Vemos si alguno ha cambiado de cero a más llegados...
        let conResultados = now.filter(a => a.numero_llegados > 0)
        if (conResultados.length) {
          conResultados.sort((a, b) => a.distancia - b.distancia)
          // Ahora buscamos cada control para ver si ha aumentado...
          let newControlId = null
          for (let i = (conResultados.length - 1); i >= 0; i--) {
            let control = conResultados[ i ]
            let find = old.filter(a => a.id === control.id)
            // console.info(control.nombre, control.numero_llegados !== find[0].numero_llegados)
            if (find.length && parseInt(find[ 0 ].numero_llegados, 10) === 0) {
              newControlId = parseInt(find[ 0 ].id, 10)
              break
            }
          }
          if (newControlId) {
            this.setState({
              controlId: newControlId,
              generoSelectedIndex: 1
            })
          } else {
            // this.setState({ controlId: parseInt(now[ 0 ].id) })
          }
        } else {
          // Vamos al primero
          if (now && now.length) {
            this.setState({ controlId: parseInt(now[ 0 ].id, 10) })
          }
        }
      }
    }

    if (this.state.controlId !== nextState.controlId) {
      // Cambiamos de control y/o filtro por sexo
      this._seleccionaResultadosAdecuados(nextState)
    } else if (this.state.generoSelectedIndex !== nextState.generoSelectedIndex) {
      // Cambiamos el filtro por sexo.
      this._seleccionaResultadosAdecuados(nextState)
    }

    // ???
    if (this.state.competicion !== nextState.competicion) {
      // Si cambia el número de resultados a mostrar actualizamos los resultados (limit..)
      if (nextState.competicion && nextState.competicion.resultados_control_mostrar) {
        this._seleccionaResultadosAdecuados(nextState)
      }
      // Obtenemos el evento
      if (nextState.competicion) {
        this.unlisten.evento = this.props.firestore.doc('evento/' + nextState.competicion.evento_id).onSnapshot(snapshot => {
          let evento = snapshot ? snapshot.data() : null
          if (evento) {
            evento.id = snapshot.id
          }
          this.setState({ evento })
        })
      }
    }
  }

  componentWillUnmount () {
    // Desconectamos todos os "listeners" de firestore para evitar problemas de memoria
    if (this.unlisten.evento) {
      this.unlisten.evento()
    }
    if (this.unlisten.competicion) {
      this.unlisten.competicion()
    }
    if (this.unlisten.controles) {
      this.unlisten.controles()
    }
    if (this.unlisten.resultados) {
      this.unlisten.resultados()
    }
    if (this.unlisten.sectores) {
      this.unlisten.sectores()
    }
  }

  render () {
    const evento = this.state.evento
    const competicion = this.state.competicion

    // @todo: ????
    let control = null
    if (this.state.controles && this.state.controlId) {
      control = this.state.controles.filter(c => {
        return parseInt(c.id, 10) === parseInt(this.state.controlId, 10)
      })
      if (control && control.length) {
        control = control[ 0 ]
      }
    }

    // const mostrarPrevisionBarra = this.state.controles.filter(a => a.prevision).length > 0
    // const ahora = new Date()
    // const horaSincronizada = new Date(ahora.getFullYear(), ahora.getMonth() + 1, ahora.getDay(), 18, 15, 0, 0)

    if (this.state.competicion) {
      return <div>
        <TopHeaderMenu
          onClickBack={this.onClickBack.bind(this)}
          onClickShare={this.toogleSharePanel.bind(this)}
          competicion={this.state.competicion}
          evento={this.state.evento}
        />
        <CompeticionHeaderMenu
          competicion={this.state.competicion} selected={1}
          evento={this.state.evento}
        />
        {this.state.competicion.visible && (
          <div>
            <ControlSelector
              controlList={this.state.controles}
              competicion={this.state.competicion}
              controlId={this.state.controlId}
              navigateToControl={(controlId) => { this.setState({ controlId }) }}
            />
            {this.state.resultados ? (
              this.state.controles.length > 0 && (
                <div>
                  {this.state.competicion.mostrar_filtro_sexo && <GeneroSelector
                    selectedIndex={this.state.generoSelectedIndex}
                    toggleSexoTodos={() => { this.setState({ 'generoSelectedIndex': 1 }) }}
                    toogleSexoMasculino={() => { this.setState({ 'generoSelectedIndex': 2 }) }}
                    toogleSexoFemenino={() => { this.setState({ 'generoSelectedIndex': 3 }) }}
                  />
                  }
                  <ResultadoList
                    resultados={this.state.resultados}
                    competicion={this.state.competicion}
                    controlId={this.state.controlId}
                    controles={this.state.controles}
                    sectores={this.state.sectores}
                    control={control}
                  />
                </div>
              )
            ) : (
              <MsgNetLoading />
            )}
          </div>
        )}

        {this.state.showSharePanel && (
          <SharePanel
            close={this.toogleSharePanel.bind(this)}
            url={`/competicion/${competicion.id}`}
            title={`Líderes de carrera en vivo en la prueba ${competicion.nombre} en ${evento.nombre}`}
          />
        )}
      </div>
    } else {
      return <MsgNetLoading />
    }
  }
}

export default withFirestore(CompeticionScreen)



// WEBPACK FOOTER //
// ./src/containers/CompeticionScreen.js